<section class="content">
    <div class="container-fluid mt-3">
        <div class="row">
            <h3>Email List Report</h3>
        </div>

        <div class="row">
            <div class="col">
                <div class="row mt-2">
                    <h6>Retrieves all user emails that...</h6>
                    <ul>
                        <li class="mt-3">
                            <div class="font-weight-bold">Are Assigned to One or More of the Selected Projects <small class="text-muted">(no project selected will return all)</small></div>
                            <div>
                                <div *ngFor="let project of projects">
                                    <input class="form-check-input project-checkbox" type="checkbox" value="{{project.id}}" id="{{project.name}}">
                                    <label class="form-check-label" for="{{project.name}}">
                                    {{project.name}}
                                    </label>
                                </div>
                            </div>
                        </li>
                        <li class="mt-3">
                            <div class="mt-1 mb-2font-weight-bold">Are a Member of One or More of the Selected Roles <small class="text-muted">(no roles selected will return all)</small></div>
                            <div>
                                <div *ngFor="let role of roles">
                                    <input class="form-check-input role-checkbox" type="checkbox" value="{{role}}" id="{{role}}">
                                    <label class="form-check-label" for="{{role}}">
                                    {{role}}
                                    </label>
                                </div>
                            </div>                            
                        </li>
                    </ul>
                </div>
                <div class="mt-4">

                </div>
                <div class="mt-4">
                    <button type="button" class="btn btn-primary" (click)="run()">Run</button>
                </div>
            </div>
            <div class="col">
                <div class="text-end mb-2">
                    <button class="btn btn-secondary copy-btn" (click)="copy($event)"><i class="fas fa-copy"></i>  Copy</button>
                </div>
                <textarea rows="15" style="width: 100%;" id="emails" name="emails">{{emails}}</textarea>
            </div>
        </div>
    </div>
</section>
